function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 14,
  stroke: "white",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3918 15.0144C23.3918 16.1856 23.3596 17.3622 23.3972 18.5333C23.4778 20.7844 21.8547 22.6647 19.7102 23.2019C19.291 23.3094 18.8449 23.3738 18.4149 23.3792C16.1414 23.3953 13.8679 23.4168 11.5944 23.3792C9.69716 23.347 8.203 22.5411 7.19256 20.9025C6.80559 20.274 6.6121 19.5756 6.6121 18.8342C6.60672 16.2823 6.58523 13.7305 6.61747 11.184C6.63897 9.51854 7.47205 8.28827 8.85334 7.4072C9.71329 6.85922 10.6646 6.61209 11.6804 6.61209C13.9002 6.60672 16.1199 6.58523 18.3396 6.61747C20.296 6.64433 21.8439 7.46093 22.849 9.18008C23.2091 9.7979 23.3918 10.4802 23.3918 11.2055C23.3865 12.4733 23.3918 13.7466 23.3918 15.0144ZM7.84828 15.0037C7.84828 16.2286 7.84828 17.4589 7.84828 18.6838C7.84828 19.1727 7.93964 19.6454 8.17076 20.0806C8.91246 21.4774 10.1271 22.1113 11.6589 22.1328C13.8787 22.165 16.1038 22.1489 18.3235 22.1328C18.7051 22.1328 19.0921 22.0683 19.463 21.9716C20.941 21.5741 22.1987 20.2955 22.1557 18.4205C22.1019 16.0567 22.1449 13.6929 22.1449 11.329C22.1449 10.8079 22.0482 10.3136 21.7956 9.85699C21.0377 8.49779 19.8284 7.87997 18.3235 7.85848C16.1092 7.82625 13.9002 7.83699 11.6858 7.85848C11.2451 7.86385 10.7936 7.94444 10.369 8.07337C8.92321 8.51928 7.78378 9.80327 7.8429 11.5332C7.88052 12.6936 7.84828 13.8487 7.84828 15.0037Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9835 10.9556C17.2261 10.9504 19.0445 12.6263 19.0445 14.6889C19.0389 16.7412 17.2261 18.4171 15.0055 18.4222C12.7684 18.4274 10.9556 16.7567 10.9556 14.6837C10.9556 12.6263 12.7519 10.9607 14.9835 10.9556ZM14.9835 12.1519C13.4737 12.157 12.2284 13.307 12.2339 14.6941C12.2394 16.0812 13.4792 17.2208 15 17.2259C16.5153 17.2259 17.7606 16.0863 17.7661 14.6992C17.7606 13.2915 16.5098 12.1467 14.9835 12.1519Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.2888 10.6302C20.3008 11.1242 19.8794 11.5601 19.3797 11.5776C18.8679 11.595 18.4285 11.1765 18.4224 10.6593C18.4164 10.1536 18.8198 9.72938 19.3195 9.71194C19.8312 9.69451 20.2767 10.1188 20.2888 10.6302Z",
  fill: "white"
});

var SvgIconInstagram2 = function SvgIconInstagram2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconInstagram2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-instagram2.fa0b0d70.svg";
export { ForwardRef as ReactComponent };